// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"a743f10c","154":"cac7fc71","175":"33d6c5a9","221":"5fadd16a","225":"e7005726","447":"00dfa0a4","453":"994be4c5","531":"d914a757","719":"7e491ff4","833":"13588aec","895":"0902a15f","971":"71074da5"}[chunkId] + ".chunk.js";
};